$(".js-launch-bundle").click(function () {
  $(".bundle-modal").addClass("showme");
  $(".bundle-modal-bg").addClass("showme");
  $(".step-1").show();
  $(".step-2").hide();
  $(".step-3").hide();
});

$(".js-close-bundle").click(function () {
  $(".bundle-modal").removeClass("showme");
  $(".bundle-modal-bg").removeClass("showme");
  $(".step-1").hide();
  $(".step-2").hide();
  $(".step-3").hide();
});

$(".js-to-step-1").click(function () {
  $(".step-1").show();
  $(".step-2").hide();
  $(".step-3").hide();
});

$(".js-to-step-2").click(function () {
  $(".step-1").hide();
  $(".step-2").show();
  $(".step-3").hide();
});

$(".js-to-step-3").click(function () {
  $(".step-1").hide();
  $(".step-2").hide();
  $(".step-3").show();
});

$(".js-edit-candle").click(function () {
  $(".step-1").show();
  $(".step-2").hide();
  $(".step-3").hide();
});

const createDropDownForMonthsAndDay = function ($this) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  let selectMonth = $this.find(".js-select-month");
  let selectDay = $this.find(".js-select-day");

  for (var m = 0; m < 12; m++) {
    let month = monthNames[m];
    let monthElem = document.createElement("option");
    monthElem.value = m;
    monthElem.dataset.month = month;
    monthElem.textContent = month;
    selectMonth.append(monthElem);
  }

  var d = new Date();
  var year = d.getFullYear();

  selectMonth.on("change", AdjustDays);

  function AdjustDays() {
    var month = parseInt(selectMonth.val()) + 1;
    var value = selectDay.val();
    selectDay.empty();
    selectDay.append(`<option value="" disabled selected>Day</option>`);

    var days = new Date(year, month, 0).getDate();

    // Feb there is a leap year
    if (month == 2) {
      days += 1;
    }

    for (var d = 1; d <= days; d++) {
      var dayElem = document.createElement("option");
      dayElem.value = d;
      dayElem.textContent = d;
      selectDay.append(dayElem);
    }

    selectDay.val(+value > d - 1 ? d - 1 : value);
  }
};

const digitToLetterDayMap = [
  "zero",
  "firsts",
  "seconds",
  "thirds",
  "fourths",
  "fifths",
  "sixths",
  "sevenths",
  "eighths",
  "ninths",
  "tenths",
  "elevenths",
  "twelfths",
  "thirteenths",
  "fourteenths",
  "fifteenths",
  "sixteenths",
  "seventeenths",
  "eighteenths",
  "nineteenths",
  "twentieths",
  "twenty-firsts",
  "twenty-seconds",
  "twenty-thirds",
  "twenty-fourths",
  "twenty-fifths",
  "twenty-sixths",
  "twenty-sevenths",
  "twenty-eighths",
  "twenty-ninths",
  "thirtieths",
  "thirty-firsts",
];

const $addToCartButton = $(".bundle-modal .js-add-to-cart");

const klaviyoProductDataById = {};
const klaviyoTrackBundle = (variantIds) => {
  const products = variantIds.map((id) => klaviyoProductDataById[id]);
  products.forEach((item) => {
    if (item) {
      _learnq.push(["track", "Viewed Product", item]);
      _learnq.push([
        "trackViewedItem",
        {
          Title: item.Name,
          ItemId: item.ProductID,
          Categories: item.Categories,
          ImageUrl: item.ImageURL,
          Url: item.URL,
          Metadata: {
            Brand: item.Brand,
            Price: item.Price,
            CompareAtPrice: item.CompareAtPrice,
          },
        },
      ]);
      _learnq.push(["track", "Added to Cart", item]);
    }
  });
};
const fetchKlaviyoDataForProduct = (handle, variantId) => {
  return fetch(`/products/${handle}?section_id=klaviyo-product-data`)
    .then((res) => res.text())
    .then((htmlString) => {
      const script = new DOMParser()
        .parseFromString(htmlString, "text/html")
        .getElementById("klaviyo-product-data");
      const productData = JSON.parse(script.textContent);
      klaviyoProductDataById[variantId] = productData;
      return productData;
    });
};

const resolveBundleVariantPrice = (id, price) => {
  try {
    let igPrice =
      typeof window.igData !== "undefined"
        ? window.igData.price.getPriceByVariantId(id)
        : null;
    if (igPrice !== null) {
      return igPrice;
    }
  } catch (error) {
    // IG parse error
  }
  return price;
};

const updateModal = ({ product }) => {
  const currencySymbol = window.currencySymbol || "$";
  const featuredImage = product.image.src;
  const variant = product.variants[0];

  $(".js-candle-photo").css("background-image", `url(${featuredImage})`);
  $(".js-candle-image img").attr("src", featuredImage);
  $(".js-candle-title").text(product.title);

  const candlePrice =
    parseFloat(resolveBundleVariantPrice(variant.id, variant.price)) || 0;
  $(".js-candle-price").text(`${currencySymbol}${candlePrice.toFixed(2)}`);

  const bookPrice =
    parseFloat(
      resolveBundleVariantPrice(
        $addToCartButton.data("book-var-id"),
        parseFloat($addToCartButton.data("book-var-price")) / 100
      )
    ) || 0;
  $(".js-book-price").text(`${currencySymbol}${bookPrice.toFixed(2)}`);

  if ($addToCartButton.data("discount-factor")) {
    const discountFactor = parseFloat($addToCartButton.data("discount-factor"));
    const originalTotal = candlePrice + bookPrice;
    const discountTotal = originalTotal * discountFactor;
    $(".bundle-modal .js-final-price .js-original-total-price").text(
      currencySymbol + originalTotal.toFixed(2)
    );
    $(".bundle-modal .js-final-price .js-total-price").text(
      currencySymbol + discountTotal.toFixed(2)
    );
  }

  $addToCartButton.data("variant-id", variant.id);

  fetchKlaviyoDataForProduct(product.handle, variant.id);
};

const addToCart = (candleVariantId, bookVariantId, bundleName) => {
  const bundleId = Date.now();
  // $.post("/cart/add.js", {
  window.BIRTHDATE_CART.addItemsToCart(
    {
      items: [
        // Candle
        {
          quantity: 1,
          id: candleVariantId,
          properties: {
            _bundle: bundleName,
            _bundle_id: bundleId,
          },
        },
        // Book
        {
          quantity: 1,
          id: bookVariantId,
          properties: {
            _bundle: bundleName,
            _bundle_id: bundleId,
          },
        },
      ],
    },
    {
      suppressAddedItemsEvent: false,
    }
  )
    .then((result) => {
      if (typeof window.handleAddBundleToCartSuccess === "function") {
        window.handleAddBundleToCartSuccess(result);
      } else {
        window.location = "/checkout";
      }
    })
    .catch((error) => console.error(error));
};

$addToCartButton.on("click", function () {
  const $this = $(this);
  const bundleName = $this.data("bundle-name") || "The Birthday Set";
  const candleVariantId = $this.data("variant-id");
  const bookVariantId = $this.data("book-var-id");
  const bookHandle = $this.data("book-handle");

  addToCart(candleVariantId, bookVariantId, bundleName);

  fetchKlaviyoDataForProduct(bookHandle, bookVariantId).then(() => {
    klaviyoTrackBundle([candleVariantId, bookVariantId]);
  });
});

$(".js-select-dates select").on("change", function () {
  const $month = $(".js-select-month");
  const $day = $(".js-select-day");
  const month = $month.find(":selected").data("month");
  const day = $day.val();

  const $button = $(".js-to-step-2");

  if (!month || !day) {
    $button.addClass("disabled");
    $button.attr("disabled", true);
    return;
  }

  $button.removeClass("disabled");
  $button.removeAttr("disabled");

  const productUrl = `/products/${month.toLowerCase()}-${
    digitToLetterDayMap[day]
  }.json`;
  fetch(productUrl)
    .then((resp) => resp.json())
    .then((data) => updateModal(data))
    .catch((error) => console.error(error));
});

$(function () {
  //caches a jQuery object containing the header element
  var ctabar = $(".js-fixed-cta-footer-jquery");
  if (ctabar.length) {
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 800) {
        ctabar.addClass("fixed-cta-footer--is-visible");
      } else {
        ctabar.removeClass("fixed-cta-footer--is-visible");
      }
    });
  }

  createDropDownForMonthsAndDay($(".js-birthdate-form"));
});

window.handleAddBundleToCartSuccess = function (result) {
  // Close popup
  $(".js-close-bundle").click();
  // Global function that will reload the cart + open it
  window.reloadAndOpenCart();
};
